import { DataBean } from "../DataBean";

export class RecordDocumentTRD extends DataBean {


    public async getHiringModalityDocumentRender(page:number,recordsPerPage:number,props:any): Promise<any> {
        return this.getCustomService("FinanceCore", "com.advantage.shared.Report_getHiringModalityDocumentRender_Number_Number_java.util.Map", 
            [page,recordsPerPage,props]);
    }
    public async updateRecordDocumentTRD(bean:any): Promise<any> {
        return this.getCustomService("ProcessFlow", "com.advantage.processflow.bean.RecordDocumentTRD_updateRecordDocumentTRD_com.advantage.processflow.bean.RecordDocumentTRD", [
            {
                DataBeanProperties:bean,
                DataBeanName:"com.advantage.processflow.bean.RecordDocumentTRD"
            }
        ]);
    }


}